module.exports = __webpack_public_path__ + "img/6.6b08b1e9.jpg";